(function () {
  var COOKIE = 'af_newsletter_dismissed';

  function hasCookie() {
    return document.cookie.indexOf(COOKIE + '=1') !== -1;
  }

  function setCookie(days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = COOKIE + '=1;expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function hasFbclid() {
    return window.location.search.indexOf('fbclid') !== -1;
  }

  // Matches the component's own mobile breakpoint in af-newsletter-popup.css
  // (@media max-width: 699px). Keep the two in sync if that changes.
  function isMobile() {
    return window.innerWidth < 700;
  }

  // The popup posts natively (see the form in af-newsletter-popup.liquid), so the
  // answer is a new page. Shopify's CAPTCHA can come first and drop the #fragment,
  // so the submit also leaves a timestamp here that says "this was the popup".
  var PENDING = 'af_nl_popup_pending';
  var PENDING_MAX_MS = 10 * 60 * 1000;

  function markPending() {
    try { sessionStorage.setItem(PENDING, String(Date.now())); } catch (e) {}
  }

  function takePending() {
    try {
      var t = parseInt(sessionStorage.getItem(PENDING), 10);
      sessionStorage.removeItem(PENDING);
      return t > 0 && Date.now() - t < PENDING_MAX_MS;
    } catch (e) {
      return false;
    }
  }

  function init(el) {
    // After a signup Shopify returns here with ?customer_posted=true (any customer
    // form: this popup or the footer). A rejected email re-renders the page with
    // form.errors, which the section marks with data-af-nl-error.
    var posted = /[?&]customer_posted=true(&|$)/.test(window.location.search);
    var errored = !!el.querySelector('[data-af-nl-error]');
    var fromPopup = false;
    if (posted || errored) {
      fromPopup = takePending() || window.location.hash === '#af-newsletter-popup-form';
    }
    // The form's #anchor has done its job; drop it so a reload or shared link is clean.
    if (window.location.hash === '#af-newsletter-popup-form') {
      try { history.replaceState(history.state, '', window.location.pathname + window.location.search); } catch (e) {}
    }

    if (!Shopify.designMode) {
      // A footer signup: they're subscribed, so don't ask again.
      if (posted && !fromPopup) {
        setCookie(parseInt(el.dataset.cookieDays, 10) || 30);
        return;
      }
      if (!fromPopup && (hasCookie() || hasFbclid())) return;
    }

    // Schema defaults: delay_desktop 8, delay_mobile 12. Both are in SECONDS.
    var delayDesktop = parseInt(el.dataset.delayDesktop, 10) || 8;
    var delayMobile = parseInt(el.dataset.delayMobile, 10) || 12;
    var cookieDays = parseInt(el.dataset.cookieDays, 10) || 30;
    var form = el.querySelector('.af-newsletter-form');
    var successMsg = el.querySelector('.af-newsletter-msg--success');
    var errorMsg = el.querySelector('.af-newsletter-msg--error');
    var closeBtn = el.querySelector('.af-newsletter-close');
    var css = document.querySelector('link[href*="af-newsletter-popup.css"]');
    var lastFocused = null;
    var prevOverflow = null;

    // No page scroll behind the popup; pad for the scrollbar so nothing shifts.
    function lockScroll() {
      if (prevOverflow !== null || Shopify.designMode) return;
      var html = document.documentElement;
      var sbw = window.innerWidth - html.clientWidth;
      prevOverflow = html.style.overflow;
      if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
      html.style.overflow = 'hidden';
    }

    function unlockScroll() {
      if (prevOverflow === null) return;
      document.documentElement.style.overflow = prevOverflow;
      document.body.style.paddingRight = '';
      prevOverflow = null;
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        setCookie(cookieDays);
        close();
      }
    }

    // Never open on top of another overlay (cart drawer, quick add, menus,
    // any open dialog). Wait and re-check every 4s instead.
    function overlayOpen() {
      var cls = (document.body.className + ' ' + document.documentElement.className);
      if (/(^|\s)overflow-hidden/.test(cls)) return true;
      if (document.querySelector('cart-drawer.active, details[open] > .menu-drawer')) return true;
      var dialogs = document.querySelectorAll('[aria-modal="true"], dialog[open]');
      for (var i = 0; i < dialogs.length; i++) {
        var d = dialogs[i];
        if (el.contains(d)) continue;
        // A closed <details> (e.g. the header search modal) still reports client
        // rects in current Chrome, which blocked the popup forever.
        if (d.closest('details:not([open])')) continue;
        if (d.getClientRects().length && getComputedStyle(d).visibility !== 'hidden') return true;
      }
      return false;
    }

    function show(tries) {
      if (!Shopify.designMode && overlayOpen()) {
        setTimeout(show, 4000);
        return;
      }
      // The stylesheet loads async (media=print swap). Right after a signup the popup
      // reopens at once, and before the CSS applies it is an unstyled box at the end
      // of the page. Wait for it (up to ~3s).
      tries = tries || 0;
      if (css && css.media !== 'all' && tries < 20) {
        setTimeout(function () { show(tries + 1); }, 150);
        return;
      }
      lastFocused = document.activeElement;
      lockScroll();
      el.style.display = 'flex';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.classList.add('is-visible');
          // Modal accessibility: trap Tab focus inside the dialog, move focus to the
          // close button, and close on Escape. Skipped in the theme editor so it can't
          // interfere with editing the preview.
          if (!Shopify.designMode) {
            if (typeof trapFocus === 'function') {
              trapFocus(el, closeBtn);
            } else if (closeBtn) {
              closeBtn.focus({ preventScroll: true });
            }
            document.addEventListener('keydown', onKeydown);
          }
        });
      });
    }

    function close() {
      el.classList.remove('is-visible');
      document.removeEventListener('keydown', onKeydown);
      unlockScroll();
      // Return focus to wherever it was before the popup stole it.
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(lastFocused);
      } else if (lastFocused && lastFocused.focus) {
        lastFocused.focus();
      }
      setTimeout(function () { el.style.display = 'none'; }, 350);
    }

    if (fromPopup && posted) {
      form.style.display = 'none';
      successMsg.style.display = 'block';
      setCookie(cookieDays);
      show();
      setTimeout(close, 3000);
    } else if (fromPopup) {
      errorMsg.style.display = 'block';
      show();
    } else if (Shopify.designMode) {
      show();
    } else {
      function delayedShow() {
        // Viewport is measured here, not at load, so a rotate or resize before
        // the scroll trigger fires still picks the right delay.
        var seconds = isMobile() ? delayMobile : delayDesktop;
        setTimeout(show, seconds * 1000);
      }
      function onScroll() {
        if (window.scrollY > 200) {
          window.removeEventListener('scroll', onScroll);
          delayedShow();
        }
      }
      if (window.scrollY > 200) {
        delayedShow();
      } else {
        window.addEventListener('scroll', onScroll, { passive: true });
      }
    }

    closeBtn.addEventListener('click', function () {
      setCookie(cookieDays);
      close();
    });

    el.addEventListener('click', function (e) {
      if (e.target === el) { setCookie(cookieDays); close(); }
    });

    // No preventDefault: the browser posts the form and Shopify handles any CAPTCHA.
    form.addEventListener('submit', function () {
      errorMsg.style.display = 'none';
      markPending();
    });
  }

  var el = document.getElementById('af-newsletter-popup');
  if (el) init(el);

  document.addEventListener('shopify:section:load', function (e) {
    var popup = e.target.querySelector('#af-newsletter-popup');
    if (popup) init(popup);
  });
})();
